import { useMemo } from 'react';

/**
 * Hook to filter memos based on expansion state and cutoff time
 * @param {Array} allMemos - All sorted memos
 * @param {boolean} memosExpanded - Whether memos are expanded
 * @param {number} memoCount - Number of memos to show when expanded
 * @param {string|null} cutoffTime - The cutoff time for filtering
 * @returns {Array} Filtered memos to display
 */
export function useFilteredMemoDisplay(allMemos, memosExpanded, memoCount, cutoffTime) {
  return useMemo(() => {
    if (memosExpanded) {
      // When expanded, show last N memos based on memoCount
      return allMemos.slice(-1 - memoCount);
    } else if (cutoffTime) {
      // When not expanded, show memos created after cutoff time
      return allMemos.filter(memo => {
        // Always show pending memos (optimistic updates)
        if (memo.isPending) return true;
        // Show memos created after the cutoff
        return memo.created_at > cutoffTime;
      });
    } else {
      // If no cutoff yet, just show the last memo
      return allMemos.slice(-1);
    }
  }, [allMemos, memosExpanded, memoCount, cutoffTime]);
}